import {ButtonDefinition} from '../buttons/button-definition';
import {BreadcrumStep} from "../services/breadcrum.service";


export class DialogWrapperConfig {
    title: BreadcrumStep[];
    subTitle?: string;
    buttonDefinition: ButtonDefinition[];
    hideSubHeader?: boolean = false;
    showHeaderBackButton?: boolean = false;

    constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/dialog-wrapper/dialog-wrapper-config.ts